import React from "react";
import { twMerge } from "tailwind-merge";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type DraggableTableRowProps = {
  id: string;
  tableId: string;
  children: React.ReactNode;
  className?: string;
};

export const DraggableTableRow: React.FC<DraggableTableRowProps> = ({
  id,
  tableId,
  children,
  className = "",
}) => {
  const { setNodeRef, transform, isDragging } = useSortable({
    id: `${tableId}-${id}`,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={twMerge(
        isDragging ? "bg-gray-100" : "",
        "hover:bg-gray-50 transition-colors",
        className,
      )}>
      {children}
    </tr>
  );
};
